module.exports = __webpack_public_path__ + "media/application/images/2024/title-2000-1de7b8202457f410dae636020afb1dde.png";